
import {EventEmitter} from 'events';
import React from 'react';
import ReactDom from 'react-dom';
import async from 'async';
import helper from './utils/helper';
import moment from 'moment';
import Api from './utils/api';
import InlineImageUploader from "./components/InlineImageUploader";

class App extends EventEmitter
{
    constructor(params) {
        super();
        params = params || {};
        this.app_url = params.app_url;
        this.api_token = params.api_token;
        this.api_endpoint = params.api_endpoint;
        this.config = params.config || {};
        this.resize_func_queue = {};

        this.translation = {};

        this.did_init = false;
        this.notice_queue = [];
        this.notice_is_shown = false;

        this.pending_queue = [];

        this.on('notice', (data) => {
            console.log('notice !!!', data);
            this.showNotice(data);
        });
        this.on('error', (err) => {
            console.error(err);
            this.emit('notice', { msg: err.pretty_message || app.trans('unknown_error'), type: 'danger' });
        });
        this.on('confirm', (params) => {
            params = params || {};
            this.confirm(params.title, params.func, params.options);
        })
    }

    getBaseUrl(l) {
        return l.protocol + '//' + l.hostname + l.pathname;
    }

    initComponents() {
        const self = this;
        const components = {
            '.inline-image-uploader': ($comps) => {
                $comps.each(function(){
                    ReactDom.render(<InlineImageUploader/>, $(this).get());
                })
            }
        };
        Object.keys(components).forEach((s) => {
            const $comp = $(s);
            if ($comp.length > 0) {
                try {
                    components[s]($comp);
                } catch (e) {
                    console.error(e);
                }
            }
        });
    };

    mountInlineImageUploader(elem, props = {}) {
        ReactDom.render(<InlineImageUploader {...props}/>, elem);
    }

    ready(done) {
        if (this.did_init) {
            return done(this);
        }
        if (this.doing_init) {
            return this.pending_queue.push(done);
        }
        this.doing_init = true;
        async.parallel([
            (done) => $(document).ready(() => done()),
        ], (err) => {
            this.did_init = true;
            const submit_button_cls = '.submit-button';

            $(submit_button_cls).each(function(i){
                $(this).on('click', function(e){
                    if ($(this).hasClass('is-loading') || $(this).hasClass('disabled')) {
                        return;
                    }
                    $(this).addClass('is-loading');
                    $(submit_button_cls).not(this).addClass('disabled').attr('disabled', true);
                    const target_form = $(this).data('target');
                    if (target_form) {
                        const $form = $('#' + target_form);
                        if ($form.length === 0) return console.warn('invalid form target');
                        const override = $(this).data('overrideFormData');
                        if (override) {
                            override.split('&').forEach((pair) => {
                                if (pair.indexOf(':') < 0) return;
                                const key_value = pair.split(':');
                                let val = key_value[1];
                                if (val.startsWith('(val)')) {
                                    val = $(val.substring(5)).val();
                                }
                                $form.find(`input[name=${key_value[0].trim()}]`).val(val.trim());
                            });
                        }
                        e.preventDefault();
                        e.stopPropagation();
                        $form.submit();
                        return false;e
                    }
                    return true;
                });
            });

            if (this.api_token) {
                // check auth
                this.checkAuthOnFocus();
            }

            $(window).on('resize', () => {
                Object.keys(this.resize_func_queue).forEach(key => {
                    const o = this.resize_func_queue[key];
                    if (!o) return;
                    if (o.interval > 0) {
                        if (o.timer) {
                            clearTimeout(o.timer);
                            o.timer = null;
                        }
                        o.timer = setTimeout(() => o.func(), o.interval);
                    } else {
                        o.func();
                    }
                });
            });

            const $languages = $('.languages');
            if ($languages.length > 0) {
                const $lang_dropdown = $languages.children('.dropdown');
                $lang_dropdown.find('.dropdown-trigger').on('click', function(){
                    $lang_dropdown.toggleClass('is-active');
                })
            }

            done(this);
            if (this.pending_queue.length > 0) {
                async.series(this.pending_queue.map(func => done => {
                    func(this);
                    done();
                }), (err) => this.pending_queue = [])
            }
        });
    }

    checkAuthOnFocus() {
        $(window).on("focus", function(e) {
            // TODO: check session
        });
    }

    showNotice(data) {
        if (typeof(data.msg) !== 'string') return;
        if (this.notice_is_shown) {
            return this.notice_queue.push(data);
        }
        this.notice_is_shown = true;
        let $notice = $('body').find('#notice');
        let $container = null;

        if ($notice.length === 0) {
            const width = Math.max(parseInt($(window).innerWidth() * .2), 300);
            $notice = $('<div></div>').attr('id', 'notice').css('width', width);
            $container = $('<div></div>').addClass('message-body');
            $notice.append($container);
            $('body').append($notice);
        }
        if (!$container) {
            $container = $notice.children('.message-body');
        }
        if ($container && $container.length > 0) {
            $notice.show(0);
            $notice.attr('class', 'message').addClass(`is-${data.type || 'info'}`);
            $container.html(data.msg);
            $notice.addClass('active');

            if (this.notice_timer) {
                clearTimeout(this.notice_timer);
            }
            this.notice_timer = setTimeout(() => {
                this.hideNotice($notice);
            }, data.msg.length * 84 + 1000);
            $notice.on('click', () => {
                if (this.notice_timer) {
                    clearTimeout(this.notice_timer);
                }
                this.hideNotice($notice);
            });
        }
    }

    hideNotice($notice) {
        $notice.addClass('out');
        setTimeout(() => {
            $notice.hide(0);
            this.notice_is_shown = false;
            if (this.notice_queue.length > 0) {
                return this.showNotice(this.notice_queue.shift());
            }
        }, 300);
    }

    api() {
        return Api({
            token: this.api_token,
            endpoint: this.api_endpoint,
            errorHandler: (err) => this.emit('error', err),
        });
    }

    helper() {
        return helper
    }

    trans(key, params = {}) {
        const ret = this.translation[key];
        return ret === undefined ? key : Object.keys(params).reduce((ret, k) => {
            return ret.replace(':' + k, params[k]);
        }, ret);
    }
}

if (window) {
    window.App = App;
    window.moment = moment;
}

export default App;
